/* ============= 公共接口 ============ */
const login = "/login"; // 登录
const repass = "/login/repass"; // 重置密码
const getCityList = "/base/getMyOrganList"; // 我的门店列表
const getMenuList = "/base/getMenuList"; // 获取栏目列表
const upImg = "/Common/uploads_uni"; // 图片上传

/* ==================管理员======================== */
/* 管理列表 */
const admin = "admin.admin";
/* 添加 */
const admin_add = "admin.admin/add";
/* 编辑 */
const admin_edit = "admin.admin/edit";
/* 删除 */
const admin_delete = "admin.admin/delete";
/* 查询 */
const admin_find = "admin.admin/find";
/* 改变状态 */
const admin_changeStatus = "admin.admin/changeStatus";
/* 权限列表 */
const admin_role = "admin.role";
/* 开通门店列表 */
const admin_city = "base/getCityList";

/* ============= 门店管理接口 ============ */
const organListAll = "/gw.organ"; // 所有门店列表
const organAdd = "/gw.organ/add"; // 添加门店
const organFind = "/gw.organ/find"; // 门店详情
const organEdit = "/gw.organ/edit"; // 修改门店
const organDel = "/gw.organ/delete"; // 删除门店

/* ============= 老师管理接口 ============ */
const teacherList = "/gw.Teacher"; // 老师列表
const teacherAdd = "/gw.Teacher/add"; // 添加老师
const teacherFind = "/gw.Teacher/find"; // 老师详情
const teacherEdit = "/gw.Teacher/edit"; // 修改老师
const teacherDel = "/gw.Teacher/delete"; // 删除老师

/* ============= 班级管理接口 ============ */
const classList = "/gw.Classr"; // 班级列表
const classAdd = "/gw.Classr/add"; // 添加班级
const classFind = "/gw.Classr/find"; // 班级详情
const classEdit = "/gw.Classr/edit"; // 修改班级
const classDel = "/gw.Classr/delete"; // 删除班级
const classFilter = "/gw.Classr/searchParam"; // 筛选


/* ============= 学员管理接口 ============ */
const student = "/gw.Student"; // 学员列表
const studentAdd = "/gw.Student/add"; // 添加学员
const studentEdit = "/gw.Student/edit"; // 修改班级
const studentFilter = "/gw.Student/searchParam"; // 筛选
const studentFind = "/gw.Student/find"; // 学员详情
const studentDel = "/gw.Student/delete"; // 删除学员


/* ============= 排课管理接口 ============ */
const course = "/gw.Course"; // 学员列表
const courseAdd = "/gw.Course/add"; // 添加排课
const courseEdit = "/gw.Course/edit"; // 修改班级
const courseFilter = "/gw.Course/searchParam"; // 筛选
const courseDel = "/gw.Course/delete"; // 删除课程
const courseStatusAdd = "/gw.Course/CourseStatus_add"; // 停课
const courseStatusDel = "/gw.Course/CourseStatus_delete"; // 恢复上课


/* ========== 课程人员详情 ========= */
const signIn = '/gw.StudentCourse/SignIn' // 课程人员信息
const leaveList = '/gw.StudentCourse/Leave' // 请假记录列表
const studentOper = '/gw.StudentCourse/studentOper' // 学生请假状态改变
const cancelStudentOper = '/gw.StudentCourse/cancel_studentOper' // 学生签到状态改变


/* ============= 星期排课管理接口 ============ */
const weekCourse = "/gw.WeekCourse"; // 学员列表
const weekCourseAdd = "/gw.WeekCourse/add"; // 添加排课
const weekCourseEdit = "/gw.WeekCourse/edit"; // 修改班级
const weekCourseFilter = "/gw.WeekCourse/searchParam"; // 筛选
const weekCourseDel = "/gw.WeekCourse/delete"; // 删除课程


const wxQrcode = "/gw.Student/GetWxQrcode"; // 获取二维码



/* ============= 学员风采 ============ */
const studentElde = "/gw.StudentElde"; // 学员风采列表
const studentEldeAdd = "/gw.StudentElde/add"; // 添加学员风采
const studentEldeDel = "/gw.StudentElde/delete"; // 删除学员风采



/* ============= 消课和消课 ============ */
const eliminate = "/gw.StudentCourse/Eliminate"; // 消课记录
const leave = "/gw.StudentCourse/Leave"; // 请假记录
const examineLeave = "/gw.StudentCourse/ExamineLeave"; // 消课/请假 审核
const searchParam = "/gw.StudentCourse/searchParam"; // 消课/请假-筛选条件
const searchDel = "/gw.StudentCourse/delete"; // 删除请假/消课


/* ============ excal导出 ============= */
const studentExcel = "/gw.Excels/StudentExcel"; // 学员信息导出








/* ============================= */
/* ==================公用接口======================= */


/* 楼盘列表 */
const houseLists = "floor.house/getHouseLists";
/* 扩展菜单 */
const linKmenu = "floor.Linkmenu";
/* 获取区域 */
const agent_getAreaList = "base/getAreaList";
/* 图片上传 */
// const upImg = "common/upload";

/* ==================登录======================= */
/* 验证码 */
const sendCode = "login/sendCode";
/* 重置密码验证码 */
const repassCode = "login/repassCode";



/* ==================咨询师======================= */
/* 咨询师列表 */
const agent = "member.agent";
/* 添加咨询师 */
const agent_add = "member.agent/add";
/* 编辑咨询师 */
const agent_edit = "member.agent/edit";
/* 删除咨询师 */
const agent_delete = "member.agent/delete";
/* 获取咨询师信息 */
const agent_find = "member.agent/find";
/* 权重 */
const agent_order = "member.agent/change?scene=order";
/* 咨询师角色列表 */
const role_list = "member.agent/role_list";
/* 驻守列表(待审核 - 已驻守 -未通过) */
const garrisonList = "member.agent/GarrisonList";
/* 批量取消驻守 */
const saveGarrison_ids = "floor.Garrison/saveGarrison_ids";
/* 驻守审核 */
const examine = "floor.Garrison/examine";
/* 接听400状态改变-已审核 */
const houseBindType = "floor.Garrison/HouseBindType";
/* 接听400状态改变-审核中 */
const saveHouseType = "floor.Garrison/SaveHouseType";


/* ==================团队======================= */
/* 团队列表 */
const team = "member.team";
/* 团队详情 */
const teamRow = "member.team/row";
/* 添加/编辑团队 */
const teamSave = "member.team/save";
/* 删除团队 */
const teamDel = "member.team/del";


/* ==================客户======================== */
/* 客户列表 */
const order = "member.index";
/* 客户详情 */
const order_detail = "member.index/details";
/* 客户导出 */
const order_export = "member.Index/export";


/* ==================渠道管家======================== */
/* 人员列表 */
const condition = "canal.HouseDisbut/condition";
/* 修改添加分销楼盘 */
const houseDisbutSave = "canal.HouseDisbut/save";
/* 分销楼盘列表 */
const houseDisbut = "canal.HouseDisbut";
/* 分销楼盘详情 */
const houseDisbutFind = "canal.HouseDisbut/find";
/* 上架下架楼盘 修改权重 */
const HouseDisbutSaveStatus = "canal.HouseDisbut/SaveField";


/* ==================问答管理======================== */
/* 问答列表 */
const question = "floor.question";
/* 查询问题 */
const question_find = "floor.question/find";
/* 添加问题 */
const question_add = "floor.question/add";
/* 编辑问题 */
const question_edit = "floor.question/edit";
/* 删除问题 */
const question_delete = "floor.question/delete";
/* 修改问题状态 */
const question_changeStatus = "floor.question/changeStatus";
/* 答案列表 */
const answer = "floor.answer";
/* 添加答案 */
const answer_add = "floor.answer/add";
/* 批量添加答案 */
const answer_batchAdd = "floor.answer/batchAdd";
/* 编辑答案 */
const answer_edit = "floor.answer/edit";
/* 删除答案 */
const answer_delete = "floor.answer/delete";
/* 修改答案状态 */
const answer_changeStatus = "floor.answer/changeStatus";

/* ==================楼盘动态管理======================== */
/* 楼盘动态列表 */
const news = "floor.news";
/* 添加楼盘动态 */
const news_add = "floor.news/add";
/* 编辑楼盘动态 */
const news_edit = "floor.news/edit";
/* 删除楼盘动态 */
const news_delete = "floor.news/delete";
/* 修改楼盘动态状态 */
const news_changeStatus = "floor.news/changeStatus";
/* 楼盘动态查询 */
const news_find = "floor.news/find";
/* 添加动态|编辑动态|草稿箱 */
const news_postEdit = "floor.news/postEdit";
// 驻守楼盘列表
const garrisonHouseList = "floor.Garrison/HouseList";
// 驻守驻守区域
const garrisonRegionList = "floor.Garrison/regionList";

/* ==================点评管理======================== */
/* 点评列表 */
const comment = "floor.comment";
/* 添加点评 */
const comment_add = "floor.comment/add";
/* 编辑点评 */
const comment_edit = "floor.comment/edit";
/* 删除点评 */
const comment_delete = "floor.comment/delete";
/* 查询 */
const comment_find = "floor.comment/find";
/* 修改点评状态 */
const comment_changeStatus = "floor.comment/changeStatus";
// 批量添加点评回复
const comment_batchAdd = "floor.commentReply/batchAdd";

/* ==================楼盘管理======================== */
/* 楼盘列表 */
const House = "floor.House";
/* 添加 */
const House_add = "floor.House/add";
/* 删除 */
const House_del = "floor.House/del";
/* 编辑 */
const House_edit = "floor.House/edit";
/* 楼盘详情 */
const House_find = "floor.House/find";
/* 楼盘排序 */
const House_order = "floor.House/change?scene=order";
/* 楼盘状态 */
const House_status = "floor.House/change?scene=status";
/* 添加修楼盘选项列表 */
const houseOptions = 'floor.house/Options'
/* 添加修楼盘区域板块列表 */
const areaPlateList = 'floor.AreaPlate/list'

/* 更改楼盘开发和优惠状态 */
const saveIsDiscountOpen = 'floor.House/SaveIsDiscountOpen'

/* 活动设置 */
const activityType = "floor.House/activityType";
const setActivityHouse = "floor.House/setActivityHouse";
const getActivityInfo = "floor.House/getActivityInfo";

/* 管家驻守列表 */
const GarrisonAgentList = "floor.Garrison/GarrisonAgentList";
/* 管家驻守 */
const addGarrison = "floor.Garrison/AddGarrison";
/* 取消管家驻守 */
const saveGarrison = "floor.Garrison/saveGarrison";
/* 全部管家列表 */
const agentList = "floor.Garrison/AgentList";

/* 区县板块列表 */
const areaPlate = "floor.AreaPlate";
/* 区县板块删除 */
const AreaPlateDelete = "floor.AreaPlate/delete";
/* 区县板块修改排序 */
const saveOrder = "floor.AreaPlate/saveOrder";

/* 添加修改区县/区县板块 */
const save = "floor.AreaPlate/save";

/* 价格筛选列表 */
const screenPrice = "floor.ScreenPrice";
/* 价格模块删除 */
const ScreenPriceDelete = "floor.ScreenPrice/delete";
/* 价格板块修改排序 */
const ScreenPriceSaveOrder = "floor.ScreenPrice/saveOrder";
/* 添加修改区县/区县板块 */
const screenPriceSave = "floor.ScreenPrice/save";

/* 地铁线 地铁站列表 */
const metroStation = "floor.MetroStation";
/* 添加修改 地铁线 */
const metroSave = "floor.Metro/save";
/* 删除地铁线 */
const metroDelete = "floor.Metro/delete";
/* 添加修改 地铁站 */
const metroStationSave = "floor.MetroStation/save";
/* 删除地铁站 */
const metroStationSaveDelete = "floor.MetroStation/delete";
/* 地铁站 修改排序 */
const metroStationSaveOrder = "floor.MetroStation/saveOrder";

/* ==================楼盘介绍======================== */
/* 楼盘介绍提交 */
const buildingStore_add = "floor.House/buildingStore";
/* ==================400电话======================== */
/* 400电话提交 */
const phoneStore_add = "floor.House/phoneStore";

/* ==================户型图======================== */
/* 户型图列表 */
const houseType = "floor.houseType";
/* 添加 */
const houseType_add = "floor.houseType/add";
/* 编辑 */
const houseType_edit = "floor.houseType/edit";
/* 删除 */
const houseType_delete = "floor.houseType/delete";
/* 查询 */
const houseType_find = "floor.houseType/find";
/* ==================楼盘相册列表======================== */
/* 楼盘相册列表 */
const housePhoto = "floor.HousePhoto/new_index";
/* 楼盘相册分类列表 */
const housePhoto_photoType = "floor.HousePhoto/new_getPhotoType";
/* 添加 */
const housePhoto_add = "floor.housePhoto/add";
/* 批量编辑 */
const housePhoto_editAll = "floor.housePhoto/editAll";
/* 批量删除 */
const housePhoto_delete = "floor.housePhoto/delete";
/* 批量移动 */
const housePhoto_moveAll = "floor.housePhoto/moveAll";
/* 设为封面 */
const housePhoto_pushFacade = "floor.housePhoto/pushFacade";
/* ==================咨询师======================== */
/* 咨询师列表 */
const houseAgent = "floor.houseAgent";
/* 添加 */
const houseAgent_add = "floor.houseAgent/add";
/* 编辑 */
const houseAgent_edit = "floor.houseAgent/edit";
/* 删除 */
const houseAgent_delete = "floor.houseAgent/delete";
/* 查询 */
const houseAgent_find = "floor.houseAgent/find";

/* ==================配置管理======================== */
/* 集客宝回收公客池时间配置查询 */
const configRow = "config.Config/row";
/* 集客宝回收公客池时间配置更改 */
const configSave = "config.Config/save";

/* ==================广告======================== */
/* 广告位列表 */
const posterSpace = "ad.posterSpace";
/* 广告位列表 */
const posterSpace_lists = "ad.PositionCate/lists";
/* 广告列表 */
const Position = "ad.poster";
/* 添加 */
const Position_add = "ad.poster/add";
/* 删除 */
const Position_del = "ad.poster/del";
/* 编辑 */
const Position_edit = "ad.poster/edit";
/* 查询 */
const Position_find = "ad.poster/find";
/* 修改状态 */
const Position_changeStatus = "ad.poster/change?scene=status";
/* 修改排序 */
const Position_order = "ad.poster/change?scene=order";

/* 广告示例 */
const ad_dome = "ad.dome";

/* ==================链接管理======================== */
/* 链接列表 */
const link = "mixed.link";
/* 添加 */
const link_add = "mixed.link/add";
/* 编辑 */
const link_edit = "mixed.link/edit";
/* 删除 */
const link_delete = "mixed.link/delete";
/* 查询 */
const link_find = "mixed.link/find";

/* ======================热销楼盘======================== */
/* 广告位首页 */
const PositionCate = "ad.PositionCate";
/* 广告位列表 */
const PositionCate_lists = "ad.PositionCate/lists";
/* 广告列表 */
const houst_Position = "ad.Position";
/* 添加广告 */
const houst_Position_add = "ad.Position/add";
/* 编辑 */
const houst_Position_edit = "ad.Position/edit";
/* 删除 */
const houst_Position_delete = "ad.Position/delete";
/* 查询 */
const houst_Position_find = "ad.Position/find";
/* 状态 */
const houst_Position_changeStatus = "ad.Position/change?scene=status";
/* 权重 */
const houst_Position_order = "ad.position/change?scene=order";

/* ==================资讯======================== */
/* 资讯列表 */
const article = "article.article";
/* 添加 */
const article_add = "article.article/add";
/* 编辑 */
const article_edit = "article.article/edit";
/* 删除 */
const article_delete = "article.article/delete";
/* 查询 */
const article_find = "article.article/find";
/* 状态 */
const article_changeStatus = "article.article/changeStatus";
/* 类型 */
const article_article_cate = "article.article_cate";
/* 推荐 */
const article_changeRecommon = "article.article/changeRecommon";
/* 添加，编辑，存草稿 */
const article_postEdit = "article.article/postEdit";



/* ==================流量宝======================== */
/* 大区列表 */
const crm_regionList = "crm.Division/regionList";
/* 事业部列表 */
const crm_divisioList = "crm.Division/divisioList";
/* 售楼部列表 */
const crm_houseList = "crm.Division/houseList";
/* 人员列表 */
const crm_index = "crm.Admin/index";
/* 人员详情 */
const crm_find = "crm.Admin/find";
/* 添加人员 */
const crm_Adminadd = "crm.Admin/add";
/* 添加人员 */
const crm_Adminedit = "crm.Admin/edit";
/* 删除人员 */
const crm_AdminchangeStatus = "crm.Admin/changeStatus";
/* 团队列表 */
const crm_Teamindex = "crm.Team/index";
/* 添加团队 */
const crm_Teamadd = "crm.Team/add";
/* 角色列表 */
const crm_getRoleList = "crm.Admin/getRoleList";
/* 切换列表 */
const crm_divisionList = "crm.Division/divisionList";
/* 删除大区 */
const crm_divisionDelete = "crm.Division/delete";
/* 添加大区 */
const crm_addRegion = "crm.Division/addRegion";
/* 编辑大区 */
const crm_editRegion = "crm.Division/editRegion";
/* 添加事业部 */
const crm_addDivisio = "crm.Division/addDivisio";
/* 编辑事业部 */
const crm_editDivisio = "crm.Division/editDivisio";
/* 添加售楼部 */
const crm_addHouse = "crm.Division/addHouse";
/* 编辑事业部 */
const crm_editHouse = "crm.Division/editHouse";

/* ==================全域营销网站======================== */
/* 客户列表 */
const signup_signup = "signup.signup";
/* 文章列表 */
const signup_signup_globalArticle = "signup.signup/globalArticle";
/* 修改文章 */
const signup_signup_editArticle = "signup.signup/editArticle";
/* 添加文章 */
const signup_signup_AddglobalArticle = "signup.signup/AddArticle";
/* 删除文章 */
const signup_signup_delArticle = "signup.signup/delArticle";
/* 文章详情 */
const signup_signup_rowArticle = "signup.signup/rowArticle";
/* 修改状态 */
const signup_signup_statusArticle = "signup.signup/statusArticle";
/* 文章排序 */
const signup_signup_orderArticle = "/signup.signup/orderArticle";

/* ==================人员管理======================== */
/* 人员列表 */
const personnelList = "crm.Admin/personnelList";
/* 添加用户 */
const addUser = "crm.Admin/AddUser";
/* 修改用户 */
const editUser = "crm.Admin/EditUser";
/* 改变用户状态 */
const saveUserStaus = "crm.Admin/SaveUserStaus";
/* 用户详情 */
const userRow = "crm.Admin/UserRow";
/* 用户列表 - 筛选项 */
const userFilteritems = "crm.Admin/UserFilteritems";
/* 大区-事业部-售楼部 列表筛选(左侧三级) */
const divisionList = "crm.Admin/DivisionList";
/* 售楼处列表 */
const houseList = "crm.Admin/HouseList";
/* 售楼部解绑 */
const houseUnbundling = "crm.Admin/HouseUnbundling";

/* =====================项目管理===================== */

/* 启用||禁用 */
const enableDisable = "crm.Admin/EnableDisable";
/* 集团列表 */
const groupList = "crm.Admin/GroupList";
/* 添加集团 */
const addGroup = "crm.Admin/AddGroup";
/* 修改集团 */
const editGroup = "crm.Admin/EditGroup";
/* 集团-人员列表 */
const grouppersonnelList = "crm.Admin/GrouppersonnelList";
/* 集团-事业部列表 */
const groupDivisionList = "crm.Admin/GroupDivisionList";
/* 集团-售楼部列表 */
const groupHouseList = "crm.Admin/GroupHouseList";

/* 事业部列表 */
const divisionLists = "crm.Admin/DivisionLists";
/* 添加事业部-集团名单 */
const jtList = "crm.Admin/jtList";
/* 新增/修改事业部 */
const divisionAdd = "crm.Admin/DivisionAdd";
/* 事业部-人员列表 */
const divisionpersonnelList = "crm.Admin/DivisionpersonnelList";
/* 事业部-售楼处列表 */
const divisionHouseList = "crm.Admin/DivisionHouseList";

/* 售楼部列表 */
const getHouseLists = "crm.Admin/HouseLists";
/* 售楼部-人员列表 */
const houseUserList = "crm.Admin/HouseUserList";
/* 产品列表 */
const jurisdiction = "crm.Admin/Jurisdiction";
/* 售楼部添加 */
const groupHouseSave = "crm.Admin/GroupHouseSave";
/* 售楼部修改详情 */
const houseRow = "crm.Admin/HouseRow";
/* 筛选禁用列表 */
const sessrnstatus = "crm.Admin/Sessrnstatus";

export default {
  /*     sendCode,
      login,
      repassCode,
      repass,
      upImg,
  
  
      houseLists,
      linKmenu,
      agent,
      agent_add,
      agent_edit,
      agent_delete,
      agent_find,
      agent_order,
      agent_getAreaList,
      order,
      order_detail,
      order_export,
      question,
      question_find,
      question_add,
      question_edit,
      question_delete,
      question_changeStatus,
      answer,
      answer_add,
      answer_batchAdd,
      answer_edit,
      answer_delete,
      answer_changeStatus,
      news,
      news_add,
      news_edit,
      news_delete,
      news_changeStatus,
      news_find,
      news_postEdit,
      comment,
      comment_add,
      comment_edit,
      comment_delete,
      comment_find,
      comment_changeStatus,
      comment_batchAdd,
      House,
      House_add,
      House_del,
      House_edit,
      House_find,
      House_status,
      House_order,
      buildingStore_add,
      phoneStore_add,
      activityType,
      setActivityHouse,
      getActivityInfo,
      houseType,
      houseType_add,
      houseType_edit,
      houseType_delete,
      houseType_find,
      housePhoto,
      housePhoto_photoType,
      housePhoto_add,
      housePhoto_editAll,
      housePhoto_delete,
      housePhoto_moveAll,
      housePhoto_pushFacade,
      houseAgent,
      houseAgent_add,
      houseAgent_edit,
      houseAgent_delete,
      houseAgent_find,
      posterSpace,
      posterSpace_lists,
      Position,
      Position_add,
      Position_edit,
      Position_find,
      Position_del,
      Position_changeStatus,
      Position_order,
      ad_dome,
      link,
      link_add,
      link_edit,
      link_delete,
      link_find,
      PositionCate,
      PositionCate_lists,
      houst_Position,
      houst_Position_add,
      houst_Position_edit,
      houst_Position_delete,
      houst_Position_find,
      houst_Position_changeStatus,
      houst_Position_order,
      article,
      article_add,
      article_edit,
      article_delete,
      article_find,
      article_changeStatus,
      article_article_cate,
      article_changeRecommon,
      article_postEdit,
      admin,
      admin_add,
      admin_edit,
      admin_delete,
      admin_find,
      admin_changeStatus,
      admin_role,
      admin_city,
      crm_regionList,
      crm_divisioList,
      crm_houseList,
      crm_index,
      crm_find,
      crm_Adminadd,
      crm_Adminedit,
      crm_AdminchangeStatus,
      crm_Teamindex,
      crm_Teamadd,
      crm_getRoleList,
      crm_divisionList,
      crm_divisionDelete,
      crm_addRegion,
      crm_editRegion,
      crm_addDivisio,
      crm_editDivisio,
      crm_addHouse,
      crm_editHouse,
      signup_signup,
      signup_signup_globalArticle,
      signup_signup_editArticle,
      signup_signup_AddglobalArticle,
      signup_signup_delArticle,
      signup_signup_rowArticle,
      signup_signup_statusArticle,
      signup_signup_orderArticle,
      personnelList,
      addUser,
      editUser,
      userFilteritems,
      divisionList,
      userRow,
      houseList,
      houseUnbundling,
      saveUserStaus,
      groupList,
      addGroup,
      editGroup,
      grouppersonnelList,
      groupHouseList,
      groupDivisionList,
      divisionLists,
      jtList,
      divisionAdd,
      divisionpersonnelList,
      getHouseLists,
      houseUserList,
      enableDisable,
      jurisdiction,
      groupHouseSave,
      houseRow,
      sessrnstatus,
      divisionHouseList,
      save,
      saveOrder,
      AreaPlateDelete,
      areaPlate,
      screenPriceSave,
      ScreenPriceSaveOrder,
      ScreenPriceDelete,
      screenPrice,
      metroStationSaveOrder,
      metroStationSaveDelete,
      metroStationSave,
      metroStation,
      metroDelete,
      metroSave,
      garrisonHouseList,
      garrisonRegionList,
      GarrisonAgentList,
      saveGarrison,
      agentList,
      addGarrison,
      houseOptions,
      configRow,
      configSave,
      role_list,
      areaPlateList,
      saveIsDiscountOpen,
      garrisonList,
      saveGarrison_ids,
      examine,
      houseBindType,
      team,
      teamDel,
      teamSave,
      teamRow,
      saveHouseType,
      condition,
      houseDisbutSave,
      houseDisbut,
      houseDisbutFind,
      HouseDisbutSaveStatus, */

  /* -------- */

  getCityList,
  getMenuList,
  login,
  repass,

  admin,
  admin_add,
  admin_edit,
  admin_delete,
  admin_find,
  admin_changeStatus,
  admin_role,
  admin_city,


  organListAll,
  organAdd,
  organDel,
  organEdit,
  organFind,

  teacherList,
  teacherAdd,
  teacherFind,
  teacherEdit,
  teacherDel,

  classList,
  classAdd,
  classFind,
  classEdit,
  classDel,
  classFilter,

  student,
  studentAdd,
  studentEdit,
  studentFilter,
  studentFind,
  studentDel,

  course,
  courseAdd,
  courseEdit,
  courseFilter,
  courseDel,
  courseStatusAdd,
  courseStatusDel,

  weekCourse,
  weekCourseAdd,
  weekCourseEdit,
  weekCourseFilter,
  weekCourseDel,


  wxQrcode,

  upImg,
  studentElde,
  studentEldeAdd,
  studentEldeDel,

  searchParam,
  eliminate,
  leave,
  examineLeave,
  searchDel,

  signIn,
  leaveList,
  studentOper,
  cancelStudentOper,

  studentExcel

};



// WEBPACK FOOTER //
// ./src/assets/js/api.js